var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-change"},[_c('explanation',{attrs:{"caption":"パスワード変更","description":"ログインパスワードを変更します。"}}),_c('input-password'),_c('button-change-password')],1)}
var staticRenderFns = []

export { render, staticRenderFns }